// extracted by mini-css-extract-plugin
var _1 = "Qekcn";
var _2 = "y_GXe";
var _3 = "d0RAh";
export { _1 as "columnsCount", _2 as "previewDataset", _3 as "spinner" }
